(function () {
    'use strict';

    angular
        .module('app.tags')
        .controller('TagsDetailController', DetailController);

    DetailController.$inject = ['$location', '$stateParams', 'TagsService'];

    function DetailController($location, $stateParams, Service) {
        /* jshint validthis:true */
        var vm = this;

        Service.get($stateParams.Id)
            .then(function (data) {
                vm.entity = data;
            });

        vm.fields = Service.getFields();

        vm.delete = function () {
            if (confirm("Silmek istediğinize emin misiniz?")) {
                Service.del(vm.entity).then(function (data) {
                    $location.path('/tags/list');
                });
            }
        };
    }
})();